import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Api } from "@/api";
import { cacheFunctionData } from "@/utils";
import Button from "~/components/common/button";
import { showPopup } from "~/redux/action-creaters/popup";
import { popupTypes } from "~/redux/reducers/popupReducer";

import DeliveryMap from "..";
import styles from "./index.module.scss";

export default function SdekMap({ isError }: any) {
  const dispatch = useDispatch();
  const [sdekPoints, setSdekPoints] = useState<any[]>([]);
  const { cityName } = useSelector((state: any) => state.location);
  const [isLoading, setIsLoading] = useState(false);
  const { basket } = useSelector((state: any) => state.cart);

  const points = useMemo(() => {
    return sdekPoints.map((item) => {
      return {
        ID: item.ID,
        NAME: item.ADR,
        TITLE: "СДЭК",
        WORK_TIME: item.WORK_TIME,
        PRICE: basket?.PRICE >= 10000 ? 200 : 400,
        PRICE_DOP: 650,
        IS_TK: true,
        GPS_N: item.GPS_N,
        GPS_S: item.GPS_S,
      };
    });
  }, [sdekPoints, basket]);

  const getSdekPoints = async () => {
    setIsLoading(true);
    const points = await cacheFunctionData(
      () => {
        return Api.server.getSdekPoints(cityName);
      },
      "sdekPoints",
      true,
    );
    setSdekPoints(points);
    setIsLoading(false);
  };

  useEffect(() => {
    if (cityName) {
      getSdekPoints();
    }
  }, [cityName]);

  return (
    <DeliveryMap
      isError={isError}
      title={
        <div className={styles.Location}>
          Выберите пункт выдачи и способ оплаты в г.{cityName}
          <Button
            type="outline"
            onClick={() => dispatch(showPopup(popupTypes.locationNew))}
            label="Сменить город?"
          />
        </div>
      }
      isTk
      points={points}
      isLoading={isLoading}
    />
  );
}
